import styled from "styled-components";
import { globalStyles } from "../../util/globalStyles";

export const BrochureShortcutWrapper = styled.div`
    height: 80px;
    width: 80px;
    border: 2px solid rgb(255, 204, 0);
    border-radius: 50%;
    position: fixed;
    bottom: 50px;
    right: 50px;
    z-index: 9;
    cursor: pointer;
    filter: drop-shadow(0 0 0.25rem #6c533f);
    background-color: #fdf5d6;
    color: #6c533f;

    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 0.8rem;
    font-weight: bold;

    &:hover {
        filter: drop-shadow(0 0 0.75rem #6c533f);
    }

    @media only screen and (max-width: ${globalStyles.breakpoints.small}) {
        height: 60px;
        width: 60px;
        bottom: 25px;
        right: 25px;
        font-size: 0.7rem;
    }
`